import React from "react"
import Helmet from "react-helmet"
import Link from "gatsby-link"
import Board from "../components/board.js"
import Archives from "../templates/archives.js"
import styles from "../styles/archive.module.scss"

export default ({data}) => {
	const categorySet = new Set();
    data.allMarkdownRemark.edges.forEach(edge => {
      const {frontmatter} = edge.node
      categorySet.add(frontmatter.category)
    })
    const categoryArray = Array.from(categorySet);
	
	return (
	  <div>
	  	<Helmet
	      title={`Archives | ${data.site.siteMetadata.title}`}
	    />
	    <Archives edges={data.allMarkdownRemark.edges} category="" categories={categoryArray}/>
		{/* 写真追加・できればリンク別窓対応 */}
	  </div>
  )
}

export const query = graphql`
  query archivesQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          frontmatter {
            category
            number
            title
            date
            images
          }
          html
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/archives.js